import { Injectable } from '@angular/core';
import { ApiBaseService } from './api-base.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TranslationsApiService extends ApiBaseService {

  override scope = 'translations';

  getTranslations(locale: string): Observable<Record<string, string>> {
    return this.get<Record<string, string>>(locale);
  }


}
